<template>
  <div class="resource-filters">
    <div class="resource-filters-group" v-for="filterGroup in filterGroups" :key="filterGroup.key">
      <h5 class="filter-list-title">{{ filterGroup.name }}</h5>
      <ul class="filter-list">
        <li class="filter-item" v-for="filter in filterGroup.filters" :key="`${filterGroup.key}-${filter.id}`">
          <input type="checkbox"
            :name="`${filterGroup.key}-${filter.id}`"
            :id="`${filterGroup.key}-${filter.id}`"
            :checked="filter.checked"
            @click="onFilterClick($event, filter, filterGroup)">
          <label :for="`${filterGroup.key}-${filter.id}`">{{ filter.name }}</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    filterGroups () { return this.$store.state.resources.filterGroups }
  },

  methods: {
    onFilterClick ($event, filter, filterGroup) {
      filter.checked = $event.target.checked
      this.$store.commit('resources/setFilter', { filterGroup: filterGroup.key, filterId: filter.id, checked: filter.checked })
      this.$store.dispatch('resources/fetch')
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.filter-list-title {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  text-transform: uppercase;
  @include text-size-s();
  font-weight: $font-weight-semibold;
}

.filter-item {
  display: block;
  margin: .5rem 0;
}

</style>



// WEBPACK FOOTER //
// src/components/ResourceFilters.vue